import { setIsOpenSideBar } from 'store/uiEffects/actions';
import { selectIsOpenSidebar } from 'store/uiEffects/selectors';

import { useDispatch, useSelector } from 'hooks/store';

const useToggle = () => {
    const dispatch = useDispatch();
    const isOpenSidebar = useSelector(selectIsOpenSidebar);

    const open = () => {
        dispatch(setIsOpenSideBar(true));
    };

    const toggle = () => {
        dispatch(setIsOpenSideBar(!isOpenSidebar));
    };

    const close = () => {
        dispatch(setIsOpenSideBar(false));
    };

    return { open, close, toggle, isOpen: isOpenSidebar };
};

export default useToggle;
